import CommonService from "./CommonService";

const getIssuerContactByIssuerId = (obj) => {
    return CommonService.apicall(obj)
};

const getIssuersByUserId = (obj) => {
    return CommonService.apicall(obj)
}

const createNewContact = (obj) => {
    return CommonService.apicall(obj)
}

const getIssuersOrgs = (obj) => {
    return CommonService.apicall(obj)
}

const getIssuerId = (obj) => {
    return CommonService.apicall(obj)
}

const IssuerService = {
    getIssuerContactByIssuerId,
    getIssuersByUserId,
    createNewContact,
    getIssuersOrgs,
    getIssuerId
};


export default IssuerService;